import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { PlayerApp } from './player/PlayerApp.js';
import { PayScreen } from './player/PayScreen.js';
import { StaffApp } from './staff/StaffApp.js';
import { AdminApp } from './admin/AdminApp.js';
import { RunSheet } from './print/RunSheet.js';
import { NotFound } from './NotFound.js';

/**
 * Three surfaces, one SPA. A router library would be more code than the thing
 * it routes.
 *
 * Note what does NOT happen here any more: an unrecognised path used to fall
 * through to the player app, so /host or a typo served a plausible wrong page
 * rather than saying it did not exist.
 */
function Root() {
  // Tolerate a trailing slash; /staff and /staff/ are the same place.
  const path = location.pathname.replace(/\/+$/, '') || '/';

  if (path === '/') return <PlayerApp />;

  // /host and /door are what people guess for the two staff roles. Both are the
  // staff app, which shows the right tabs for whichever PIN signs in.
  if (['/staff', '/host', '/door'].some((p) => path === p || path.startsWith(`${p}/`))) {
    return <StaffApp />;
  }
  if (path === '/admin' || path.startsWith('/admin/')) return <AdminApp />;
  if (path === '/pay' || path.startsWith('/pay/')) return <PayScreen />;
  if (path === '/print' || path.startsWith('/print/')) return <RunSheet />;

  return <NotFound path={path} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
